<template>
  <BookDirectPolicy v-if="$siteConfig.brand ==='BookDirect'" />
  <PrivacyPolicy v-else/>
</template>

<script setup lang="ts">
import PrivacyPolicy from '@/components/Documents/PrivacyPolicy.vue'
import BookDirectPolicy from "~/components/Documents/BookDirectPolicy.vue";
const { $siteConfig } = useNuxtApp()
const runtimeConfig = useRuntimeConfig()
const brand = $siteConfig?.value?.brand || 'Tripening'

useHead({
  title: `Privacy Policy | ${brand}`,
  link: [{ rel: 'canonical', href: `${runtimeConfig.public.baseURL}/privacy-policy` }],
  meta: [
    { name: 'description', content: `Read the privacy policy for ${brand}. Learn how we collect, use, and protect your personal information.` },
  ]
})
</script>

<style scoped lang="scss">

</style>
